import { useEffect, useState } from 'react';

import { formatHHMMSS } from '@shared/lib/date';

/**
 * Считает прошедшее время от метки `targetDateStr` и возвращает строку в формате HH:MM:SS.
 *
 * @param targetDateStr Временная метка начала (ISO‑строка); если не задана — таймер сбрасывается.
 * @returns Строка прошедшего времени вида `00:00:00`, обновляется каждую секунду.
 */
export const useCountdownTimer = (targetDateStr?: string | null) => {
	const [elapsedTime, setElapsedTime] = useState('00:00:00');

	useEffect(() => {
		if (!targetDateStr) {
			setElapsedTime('00:00:00');
			return;
		}

		const pastTime = new Date(targetDateStr).getTime();

		const updateTimer = () => {
			const now = Date.now();
			const elapsedSeconds = Math.max(0, Math.floor((now - pastTime) / 1000));

			setElapsedTime(formatHHMMSS(elapsedSeconds));
		};

		updateTimer();
		const timerId = setInterval(updateTimer, 1000);

		return () => clearInterval(timerId);
	}, [targetDateStr]);

	return elapsedTime;
};
